import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from '../../../../components/angle/Panel/index';
import DatePicker from '../../../../components/DatePicker';
import Select from '../../../../components/Select/index';
import { formInputValidation } from '../../../../services/helper/form-helper';

import { Toastr } from '../../../../components/Toastr/index';

const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

class SearchByFileByDatePanel extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            clientId: '',
            startDate: '',
            startDatePicker: '',
            endDate: '',
            endDatePicker: '',
            selectValue: 0
        };
        let date = new Date();
        this.dateOptions = [
            { name: 'Custom Time Period', value: 0 },
            {
                name: 'This week',
                value: 1,
                startDate: this.getFirstDayOfWeek(date),
                endDate: this.getLastDayOfWeek(date)
            },
            {
                name: 'Next week',
                value: 2,
                startDate: this.getFirstDayOfWeek(date, 7),
                endDate: this.getLastDayOfWeek(date, 7)
            }
        ];
        for (let i = 0; i < 4; i++) {
            let month = (date.getMonth() + i) % 12;
            let year =
                date.getFullYear() + Math.floor((date.getMonth() + i) / 12);

            this.dateOptions.push({
                name: monthNames[month],
                value: i + 3,
                startDate: new Date(Date.UTC(year, month, 1, 0, 0, 0)),
                endDate: new Date(Date.UTC(year, month + 1, 0, 23, 59, 59))
            });
        }
    }

    getFirstDayOfWeek = (d, offset = 0) => {
        d = new Date(d);
        let day = d.getUTCDay(),
            diff = d.getUTCDate() - day + (day === 0 ? -6 : 1);
        d.setUTCHours(0, 0, 0, 0);
        return new Date(d.setUTCDate(diff + offset));
    };

    getLastDayOfWeek = (d, offset = 0) => {
        d = new Date(d);
        let day = d.getUTCDay(),
            diff = d.getUTCDate() + (7 - day);
        d.setUTCHours(23, 59, 59);
        return new Date(d.setUTCDate(diff + offset));
    };

    componentDidMount() {
        let { user } = this.props;
        if (user && user.roleName === 'User') {
            this.setState({
                clientId: user.clientId
            });
        }
    }
    handleTimePeriodChange = (name, value) => {
        this.setState({
            startDate: value && value.value ? value.startDate : '',
            startDatePicker: '',
            endDate: value && value.value ? value.endDate : '',
            endDatePicker: '',
            selectValue: value ? value.value : 0
        });
    };

    handleDateChange = (name, value) => {
        this.setState({
            [name]: value ? value : ''
        });
    };

    handleSelectChange = (name, value) => {
        this.setState({
            [name]: value ? value[name] : ''
        });
    };

    logicValidation = () => {
        let { selectValue, startDatePicker, endDatePicker } = this.state;
        let errorMessage = '';
        if (selectValue === 0) {
            if (endDatePicker >= startDatePicker) {
                return true;
            } else {
                errorMessage =
                    'End date must be equal or greater than start date';
            }
        }
        Toastr.error(errorMessage);
        return false;
    };

    onSearch = () => {
        let { onSearchClick } = this.props;
        let {
            selectValue,
            clientId,
            startDate,
            endDate,
            startDatePicker,
            endDatePicker
        } = this.state;
        if (formInputValidation(this.formRef.current)) {
            if (selectValue === 0) {
                if (this.logicValidation()) {
                    let startDatePickerUTC = new Date(startDatePicker);
                    startDatePickerUTC.setUTCHours(0);
                    let endDatePickerUTC = new Date(endDatePicker);
                    endDatePickerUTC.setUTCHours(23, 59, 59);
                    onSearchClick(
                        clientId,
                        startDatePickerUTC,
                        endDatePickerUTC
                    );
                }
            } else {
                onSearchClick(clientId, startDate, endDate);
            }
        }
    };
    render() {
        let { clientList, user } = this.props;
        let {
            clientId,
            startDatePicker,
            endDatePicker,
            selectValue
        } = this.state;
        let viewButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSearch}
            >
                Search
            </button>
        );
        const buttonList = [viewButton];
        return (
            <Panel
                showFooter
                footerComponents={buttonList}
                panelStyle="panel-default m0"
            >
                <form ref={this.formRef}>
                    <div className="row">
                        <div className="col-md-6 mb">
                            <Select
                                id="filingByFileByDateClientId"
                                name="clientId"
                                placeholder="Choose a Client"
                                labelKey="name"
                                valueKey="clientId"
                                selectedValue={clientId}
                                onChange={this.handleSelectChange}
                                options={clientList}
                                required={true}
                                disabled={
                                    user && user.roleName !== 'Administrator'
                                }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-3">
                            <label>Time Period</label>
                            <Select
                                labelKey="name"
                                valueKey="value"
                                selectedValue={selectValue}
                                onChange={this.handleTimePeriodChange}
                                options={this.dateOptions}
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>From</label>
                            <DatePicker
                                id="filingByFileByDateStart"
                                name="startDatePicker"
                                value={startDatePicker}
                                onChange={this.handleDateChange}
                                disabled={selectValue !== 0}
                                required={selectValue === 0}
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>To</label>
                            <DatePicker
                                id="filingByFileByDateEnd"
                                name="endDatePicker"
                                value={endDatePicker}
                                onChange={this.handleDateChange}
                                disabled={selectValue !== 0}
                                required={selectValue === 0}
                            />
                        </div>
                    </div>
                </form>
            </Panel>
        );
    }
}

SearchByFileByDatePanel.propTypes = {
    onSearchClick: PropTypes.func.isRequired
};

export default SearchByFileByDatePanel;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SearchFilings/SearchByFileByDatePanel.js